import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Moment from 'moment';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import { Paginator } from 'primereact/paginator';
import { deleteMaterialDeclaration, getMaterialDeclaration } from "../Actions/MaterialDeclarationAPI";
import { confirmAlert } from 'react-confirm-alert';
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
let searchData = {
    minyear: '',
    mdidno: '',
    maxyear: '',
    supplier: '',
    sdocid: '',
    productname: '',
    productnumber: '',
    sortorder: 'asc',
    sortby: 'productname',
    pagesize: 25,
    pagenumber: 1
}
class MDCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0,
            rows: 10,
            first2: 0,
            rows2: 10,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.ResetMD === true) {
            prevState.first = 0
            dispatch({ type: "ResetMD", data: false })
        }
    }
    render() {
        const { arraylist, pageSize } = this.props;
        return (
            <div className="">
                {this.renderCardData()}
                {arraylist.count != 0 ?
                    <Paginator className="m-0 pb-3 pt-2" first={this.state.first} rows={pageSize} totalRecords={(arraylist.count) ? arraylist.count : 0} onPageChange={(e) => this.onPaginatorChange(e)}></Paginator> :
                    <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                        <div class="container">
                            <h6 className="resource-list-title no-item-card">!--No Item to Display--!</h6>
                        </div>
                    </div>
                }

            </div>
        );
    }
    onPaginatorChange(event) {
        this.setState({
            first: event.first
        });
        const { setUpdatedState } = this.props;
        setUpdatedState(event.page + 1);
    }
    renderCardData = () => {
        const { showSidePane, arraylist } = this.props;
        return arraylist['materialDeclarationslist'] && arraylist['materialDeclarationslist'].length
            ? arraylist['materialDeclarationslist'].map((item, index) => {
                return (
                    <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                        {item.isContainAboveThreshold ? <div className="arrow-right-red"></div> : <div className="arrow-right-green"></div>}
                        <div className="p-3">
                            {/* <div className="row">
                                <div className="col-lg-9">
                                    <h6 className="resource-list-title" onClick={() => this.ShowSidePanel(item.materialDeclarationId)}>{item.mdidNo}</h6>
                                </div>
                            </div> */}
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className={"col-sm-8 col-8 col-m-auto col-md-9"}>
                                        <div className="row px-3">
                                            <div className="col-sm-12 mb-1">
                                                <h6 className="resource-list-title mb-0" onClick={() => this.ShowSidePanel(item.materialDeclarationId)}>{item.mdidNo}</h6>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6 mb-2" : "col-sm-4 mb-1"}>
                                                <span><strong>Date of Declaration : </strong><span className="italicFont ">{Moment(new Date(Date.parse(item.dateOfDeclaration))).format('DD MMM YYYY')}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                                                <span><strong>MD ID No : </strong><span className="italicFont ">{item.mdidNo}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6 mb-2" : "col-sm-4"}>
                                                <span><strong>Supplier : </strong><span className="italicFont ">{item.companyName}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-4 mb-1"}>
                                                <span><strong>SDoC ID No : </strong><i aria-hidden="true" ></i><span className="italicFont">{item.sdocIdNo}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6 mb-2" : "col-sm-4"}>
                                                <span><strong>Product Number : </strong><span className="italicFont">{item.productNumber}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                                                <span><strong>Product Name : </strong><i aria-hidden="true"></i> <span className="italicFont">{item.productName}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6 mb-2" : "col-sm-4"}>
                                                <span><strong>Contact Person : </strong><span className="italicFont"> {item.contactPerson}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                                                <span><strong>Amount : </strong><span className="italicFont">{item.productQuantityAmount}</span></span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                                                <span><strong>Unit : </strong><i aria-hidden="true"></i><span className="italicFont">{item.productMetricUnit}</span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-sm-4 col-md-3 col-4 col-m-auto"} >
                                        <div className="text-center" >
                                            <i className="fa fa-eye fa-2x fa-lg click p-2" aria-hidden="true" onClick={() => this.viewMaterialDeclaration(item.materialDeclarationId)} style={{ color: " #1E3A8A" }}></i>
                                            <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" onClick={() => this.editMaterialDeclaration(item.materialDeclarationId)} style={{ color: " #1E3A8A" }}></i>
                                            <i className="fa fa-trash fa-2x fa-lg click p-2" aria-hidden="true" onClick={() => this.DeletePopup(item.materialDeclarationId)} style={{ color: " #1E3A8A" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null;
    }

    viewMaterialDeclaration = (id) => {
        const { dispatch } = this.props;
        this.props.dispatch({ type: 'MaterialDeclarationOptions', data: "View" });
        this.props.history.push(`/Home/MDAdmin/${id}`);
        // let url = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${id}`;
        // axios.get(url)
        //     .then((response) => {
        //         dispatch({
        //             type: "GetMaterialDeclarationSuccess",
        //             data: response.data,
        //         })
        //         this.props.dispatch({ type: 'MaterialDeclarationOptions', data: "View" });
        //         this.props.history.push(`/Home/MDAdmin/${id}`);
        //     })
        //     .catch((error) => {
        //         dispatch({
        //             type: "GetMaterialDeclarationFailure",
        //             error: "ERROR"
        //         })
        //     })
    }

    editMaterialDeclaration = (id) => {
        const { dispatch } = this.props;
        this.props.dispatch({ type: 'MaterialDeclarationOptions', data: "Edit" });
        this.props.history.push(`/Home/MDAdmin/${id}`);
        // let url = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${id}`;
        // axios.get(url)
        //     .then((response) => {
        //         dispatch({
        //             type: "GetMaterialDeclarationSuccess",
        //             data: response.data,
        //         })
        //         this.props.dispatch({ type: 'MaterialDeclarationOptions', data: "Edit" });
        //         this.props.history.push(`/Home/MDAdmin`);
        //     })
        //     .catch((error) => {
        //         dispatch({
        //             type: "GetMaterialDeclarationFailure",
        //             error: "ERROR"
        //         })
        //     })
    }

    DeletePopup(id) {
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.deleteMaterialDeclaration(id)
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
        }

    deleteMaterialDeclaration(id) {
        const { searchMDLibraryData, dispatch } = this.props;
        let url = `${API.DeleteMaterialDeclaration}?MaterialDeclarationId=${id}`;
        axios.delete(url)
            .then((response) => {
                toast.success('Deleted Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch(getMDSearchlist(searchData));
                dispatch({
                    type: "DeleteMaterialDeclarationSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "DeleteMaterialDeclarationFailure",
                    error: "ERROR"
                })
            })
    }

}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        ResetMD: state.SidePanReducer.ResetMD,
        searchMDLibraryData: state.MMPLDashboardReducer.SearchMDLibraryData,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MDCard));